import { Check, Code } from "@phosphor-icons/react";
import { IPractice } from "../../types/generalTypes";
import clsx from "clsx";
import { removeTags } from "../../utils/common";

export default function PracticesListItem({
  item,
  isActive,
  handleClick,
  prevMaxScore,
  order,
}: {
  item: IPractice;
  isActive: boolean;
  handleClick: () => void;
  prevMaxScore?: null | number;
  order: number;
}) {
  const isCompleted = prevMaxScore != null && prevMaxScore > 0.79;

  return (
    <div
      onClick={handleClick}
      className={clsx(
        "flex items-center gap-2 px-2.5 py-2 rounded-lg transition-all text-xs cursor-pointer",
        isActive
          ? "bg-white/[0.08] text-white font-semibold"
          : "text-white/40 hover:text-white/60 hover:bg-white/[0.03]"
      )}
    >
      {/* Status indicator */}
      <div className="shrink-0 w-5 h-5 flex items-center justify-center">
        {isCompleted ? (
          <Check size={14} weight="bold" className="text-myGreen" />
        ) : (
          <span className={clsx(
            "text-[10px] font-bold",
            isActive ? "text-white/60" : "text-white/25"
          )}>
            {order + 1}
          </span>
        )}
      </div>

      {/* Title */}
      <span className="flex-1 truncate leading-snug">
        {removeTags(item.description.title)}
      </span>

      {/* Code badge */}
      {item.type !== "TEST" && (
        <Code size={12} weight="bold" className={clsx("shrink-0", isActive ? "text-white/40" : "text-white/20")} />
      )}
    </div>
  );
}
